export const footerContent = `
<style>
    @font-face {
        font-weight: 300;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-light.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 400;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-regular.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-medium.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: bold;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-bold.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 300;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-light-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: normal;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-regular-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-medium-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: bold;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-bold-italic.woff2") format("woff2");
        font-display: swap;
    }
</style>

<style>
    .nd-footer .link {
        cursor: pointer;
        font-weight: inherit;
        text-decoration-line: none;
        background: transparent;
        border: none;
    }
    .nd-footer .link:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._primary {
        color: #0f140a;
        text-decoration-color: #0f140a;
    }
    .nd-footer .link._secondary {
        color: var(--primary-text-color, #000000cc);
        text-decoration-color: var(--primary-text-color, #000000cc);
    }
    .nd-footer .link._legal-info {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        font-weight: 500;
        color: #0000008f;
        text-decoration-color: #0000008f;
    }
    .nd-footer .link._underline-on-hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-on-hover:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-on-mouse-leave {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-on-mouse-leave:hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-none {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-none:hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-always {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-always:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._large {
        font-size: var(--font-large-font-size, 1.125rem);
        line-height: var(--font-large-line-height, 1.1112);
    }
    .nd-footer .link._medium {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
    }
    .nd-footer .link._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
    }
    .nd-footer .link._extra-small {
        font-size: var(--font-small-font-size, 0.75rem);
        line-height: var(--font-small-line-height, 1.1667);
    }
    .nd-footer .link._bold {
        font-weight: var(--bold-font-weight, 500);
    }
    .nd-footer .link._primary-colored {
        color: var(--primary-color, #00dc00);
    }

</style>
<style>
    .nd-footer {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        content-visibility: auto;
    }

    .nd-footer {
        font-family: Aeonik, sans-serif;
        letter-spacing: 0.15px;
    }

    .nd-footer * {
        box-sizing: border-box;
    }

    .nd-footer a {
        text-decoration: none;
    }

    .nd-footer button {
        font-family: inherit;
    }

    .nd-footer {
        background-color: #fafafa;
        padding: 24px;
        font-family: "Aeonik", sans-serif;
        font-size: 1rem;
        font-weight: 400;
        font-style: normal;
        font-feature-settings: "tnum";
        -webkit-font-smoothing: antialiased;
    }
    .nd-footer__inner {
        max-width: 1200px;
        width: 100%;
        margin: auto;
    }

    /* START: Styles for top links in the footer */
    .nd-footer__shortcuts {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 32px 48px;
        padding-top: 32px;
        padding-bottom: 32px;

    }
    .nd-footer__shortcut {
        display: flex;
        gap: 16px;
        align-items: center;
        letter-spacing: 0.2px;
        white-space: nowrap;

        color: #000000;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-decoration: none;
    }

    .nd-footer__shortcut:hover {
        text-decoration: underline;
    }

    .nd-footer__shortcut-icon-container {
        margin: 0;
    }
    /* Styles for footer links */
    .nd-footer__groups {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 16px 0;
        gap: 16px;
    }

    .nd-footer__groups._desktop {
        display: flex;
    }

    .nd-footer__groups._mobile {
        display: none;
    }

    .nd-footer__group {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        gap: 9px;
        min-width: 176px;
        max-width: 221px;
    }

    .nd-footer__group-name {
        color: #000000de;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        cursor: default;
        letter-spacing: 0.15px;
    }

    /* Styles for footer bottom */
    .nd-footer__info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 16px 0;
    }

    .nd-footer__social-media {
        display: flex;
        gap: 16px;
        flex: 1 1 0;
    }

    .nd-footer__social-media-link {
        border-radius: 50%;
        display: flex;
        width: 40px;
        height: 40px;
        justify-content: center;
        align-items: center;
    }

    .nd-footer__logo {
        display: flex;
    }

    .nd-footer__logo_nuuday {
        flex: 1 1 0;
        justify-content: end;
    }

    .nd-footer__separator {
        border: 1px solid rgba(0, 0, 0, 0.12);
        margin: 16px 0;
    }

    .nd-footer__separator._mobile {
        display: none;
    }

    .nd-footer__address,
    .nd-footer__legal {
        display: flex;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.15px;
    }

    .nd-footer__address {
        gap: 16px;
        cursor: default;
        font-style: normal;
    }

    .nd-footer__address-part,
    .nd-footer__legal-item {
        position: relative;
        white-space: nowrap;
    }

    .nd-footer__address-part:not(:last-child),
    .nd-footer__legal-item:not(:last-child) {
        margin-right: 1.5ch;
    }

    .nd-footer__address-part:not(:last-child)::after,
    .nd-footer__legal-item:not(:last-child)::after {
        content: '·';
        position: absolute;
        right: -1ch;
    }

    @media screen and (max-width: 1024px) {
        .nd-footer__groups {
            justify-content: flex-start;
        }

        .nd-footer__bottom-info {
            flex-direction: column;
            padding: 22px 0 8px;
        }

        .nd-footer__complex-address {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .nd-footer__address {
            flex-direction: column;
            align-items: center;
            gap: 24px;
        }

        .nd-footer__address-part:not(:last-child)::after {
            display: none;
        }

        .nd-footer__address + .nd-footer__legal {
            margin-top: 24px;
            justify-content: center;
        }
    }

    @media screen and (max-width: 768px) {

        .nd-footer__groups._desktop {
            display: none;
        }

        .nd-footer__groups._mobile {
            display: flex;
        }

        .nd-footer__shortcuts {
            padding-top: 24px;
            padding-bottom: 24px;
        }

        .nd-footer__shortcut {
            flex-direction: column;
            font-size: 16px;
            line-height: 24px;
            text-decoration: none;
        }

        .nd-footer__shortcut:hover {
            text-decoration: underline;
        }

        .nd-footer__separator {
            margin: 3px 0;
        }

        .nd-footer__separator._mobile {
            display: none;
        }

        .nd-footer__group-name {
            font-size: 20px;
            line-height: 28px;
        }

        .nd-footer__accordion {
            width: 100%;
            cursor: pointer;
            transition-duration: 0.4s;
            user-select: none;
        }

        .nd-footer__accordion-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .nd-footer__group-name {
            font-size: 18px;
            line-height: 24px;
            font-weight: 700;
            color: #000000de;
        }

        .nd-footer__accordion-header .nd-footer__accordion-icon {
            transition: transform 0.4s;
        }

        .nd-footer__accordion._active .nd-footer__accordion-icon {
            transform: rotate(180deg);
        }

        .nd-footer__accordion-panel {
            max-height: 0;
            transition: max-height 0.4s ease-out, padding 0.4s ease-out, opacity 0.4s ease-out;
            overflow-y: hidden;
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 0 24px;
            opacity: 0;
        }

        .nd-footer__accordion._active .nd-footer__accordion-panel {
            height: fit-content;
            max-height: 100vh;
            padding: 24px;
            opacity: 1;
        }

        .nd-footer__bottom-links {
            padding: 24px 0;
        }
    }

    @media screen and (max-width: 560px) {
        .nd-footer__shortcuts {
            display: grid;
            gap: 48px 40px;
            grid-template-columns: repeat(2, max-content);
        }

        .nd-footer__bottom-links {
            flex-direction: column;
            align-items: center;
            gap: 32px;
        }
    }
</style>
    <div class="nd-footer" >
        <div class="nd-footer__inner">
            <nav class="nd-footer__shortcuts">


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://selvbetjening.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/2BaQqwNVfoXdOu1oc1d6jp/c68ede9f209f9d0b002724f5a3346d9a/mit-yousee-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        Mit YouSee

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://profil.yousee.dk/?context=mail"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/13ENZDwodFmMm6ACEKUNyA/22ff6bb07d9214d7bccecd93d0c5aceb/mail-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        Webmail

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://musik.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/3PlnGDtl8OZ1t5e6jdPwWx/a27e485ee6f32a77923f778b694ae229/music-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        YouSee Musik

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://play.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/74yySyMd4CeTmzqhyCZKpz/0145a3e7beb930d0929b392cd1edca0c/play_mobile_bottom_link.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        YouSee Play

</a>
            </nav>
            <div class="nd-footer__groups _desktop">
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Hjælp</div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp"

>
                            Gå til hjælp

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://selvbetjening.yousee.dk"

>
                            Mit YouSee

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                            Driftsinformation

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                            Hastighedstest

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/flytadresse"
target="_blank"
>
                            Flyt adresse

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/kontakt"

>
                            Kontakt os

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Produkter</div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/play"

>
                            Tv &amp; Streaming

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/bredbaand"

>
                            Bredbånd

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/fibernet"

>
                            Fiber

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                            Mobilabonnementer

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner"

>
                            Mobiltelefoner

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                            Mobilt Internet

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tv-pakker"

>
                            Faste tv-pakker

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                            Smartwatch

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer"

>
                            Tilbehør

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                            Tilbudsavis

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Mærker</div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/apple"

>
                            Apple

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/samsung"

>
                            Samsung

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/google"

>
                            Google

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/xiaomi"

>
                            Xiaomi

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/sony"

>
                            Sony

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/motorola"

>
                            Motorola

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Streamingtjenester</div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/netflix"

>
                            Netflix

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tv2play"

>
                            TV 2 Play

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/viaplay"

>
                            Viaplay

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/disneyplus"

>
                            Disney+

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/max"

>
                            Max

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/nordisk-film-plus"
target="_blank"
>
                            Nordisk Film+

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/play#kanaloverblik"

>
                            Se alle streamingtjenester

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Om Yousee</div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://tdc.csod.com/ux/ats/careersite/17/home?c=tdc"

>
                            Karriere

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/butik"

>
                            Find butik

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://nuuday.dk/presse"

>
                            Presse

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://yousee.dk/5g"

>
                            5G

</a>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://kampagne.yousee.dk/nsu/butik"

>
                            YouSee Butik

</a>
                </div>
            </div>

            <hr class="nd-footer__separator _mobile">
            <div class="nd-footer__groups _mobile jsNdAccordion">
                    <div class="nd-footer__accordion jsNdAccordionItem">
                        <div class="nd-footer__accordion-header jsNdAccordionHeader">
                            <div class="nd-footer__group-name">Hjælp</div>
                            <img class="nd-footer__accordion-icon" alt="" width="14" height="9" src="https://yousee.dk/shop/images/icons/nuuday/footer_accordion_arrow_white.svg" />
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp"

>
                                    Gå til hjælp

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://selvbetjening.yousee.dk"

>
                                    Mit YouSee

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                    Driftsinformation

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                    Hastighedstest

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/flytadresse"
target="_blank"
>
                                    Flyt adresse

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/kontakt"

>
                                    Kontakt os

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion jsNdAccordionItem">
                        <div class="nd-footer__accordion-header jsNdAccordionHeader">
                            <div class="nd-footer__group-name">Produkter</div>
                            <img class="nd-footer__accordion-icon" alt="" width="14" height="9" src="https://yousee.dk/shop/images/icons/nuuday/footer_accordion_arrow_white.svg" />
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/play"

>
                                    Tv &amp; Streaming

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/bredbaand"

>
                                    Bredbånd

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/fibernet"

>
                                    Fiber

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                                    Mobilabonnementer

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner"

>
                                    Mobiltelefoner

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                                    Mobilt Internet

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tv-pakker"

>
                                    Faste tv-pakker

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                    Smartwatch

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer"

>
                                    Tilbehør

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                                    Tilbudsavis

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion jsNdAccordionItem">
                        <div class="nd-footer__accordion-header jsNdAccordionHeader">
                            <div class="nd-footer__group-name">Mærker</div>
                            <img class="nd-footer__accordion-icon" alt="" width="14" height="9" src="https://yousee.dk/shop/images/icons/nuuday/footer_accordion_arrow_white.svg" />
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/apple"

>
                                    Apple

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/samsung"

>
                                    Samsung

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/google"

>
                                    Google

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/xiaomi"

>
                                    Xiaomi

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/sony"

>
                                    Sony

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/shop/motorola"

>
                                    Motorola

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion jsNdAccordionItem">
                        <div class="nd-footer__accordion-header jsNdAccordionHeader">
                            <div class="nd-footer__group-name">Streamingtjenester</div>
                            <img class="nd-footer__accordion-icon" alt="" width="14" height="9" src="https://yousee.dk/shop/images/icons/nuuday/footer_accordion_arrow_white.svg" />
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/netflix"

>
                                    Netflix

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/tv2play"

>
                                    TV 2 Play

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/viaplay"

>
                                    Viaplay

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/disneyplus"

>
                                    Disney+

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/max"

>
                                    Max

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/nordisk-film-plus"
target="_blank"
>
                                    Nordisk Film+

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/play#kanaloverblik"

>
                                    Se alle streamingtjenester

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion jsNdAccordionItem">
                        <div class="nd-footer__accordion-header jsNdAccordionHeader">
                            <div class="nd-footer__group-name">Om Yousee</div>
                            <img class="nd-footer__accordion-icon" alt="" width="14" height="9" src="https://yousee.dk/shop/images/icons/nuuday/footer_accordion_arrow_white.svg" />
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://tdc.csod.com/ux/ats/careersite/17/home?c=tdc"

>
                                    Karriere

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/hjaelp/butik"

>
                                    Find butik

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://nuuday.dk/presse"

>
                                    Presse

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://yousee.dk/5g"

>
                                    5G

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="0"
href="https://kampagne.yousee.dk/nsu/butik"

>
                                    YouSee Butik

</a>
                        </div>
                    </div>
            </div>
            <hr class="nd-footer__separator _mobile">

            <div class="nd-footer__info nd-footer__bottom-links">
                <div class="nd-footer__social-media">
                        <a class="nd-footer__social-media-link" href="https://www.facebook.com/youseedanmark" target="_blank" >
                            <img src="//images.ctfassets.net/qn2mzafc6iit/VswOIxxKhS6dplmaR2viF/7113480aa89eb9e1d94c48d456ea27c9/facebook-dark.svg?w=40&h=40" alt="Facebook" />
                        </a>
                        <a class="nd-footer__social-media-link" href="https://www.youtube.com/channel/UC3p7fPsSYAFRI1gY95ktxkQ" target="_blank" >
                            <img src="//images.ctfassets.net/qn2mzafc6iit/6IGmIJXGjc7iT0MdgA9U6R/0a1f79c81cf84cb6c30b7bee68e6e993/youtube-dark.svg?w=40&h=40" alt="YouTube" />
                        </a>
                </div>
                <div class="nd-footer__logo nd-footer__logo_yousee">
                    <a href="https://yousee.dk">
                        <img class="nd-footer__logo-image" src="https://yousee.dk/shop/images/nuuday/yousee-logo.svg" alt="YouSee" loading="lazy" width="120" height="34"/>
                    </a>
                </div>
                <div class="nd-footer__logo nd-footer__logo_nuuday">
                    <a href=https://nuuday.com/>
                        <img class="nd-footer__logo-image" src="https://yousee.dk/shop/images/nuuday/a-nuuday-company-logo.svg" alt="Nuuday" loading="lazy" width="108" height="41"/>
                    </a>
                </div>
            </div>

            <hr class="nd-footer__separator _mobile">

            <div class="nd-footer__info nd-footer__bottom-info">
                <address class="nd-footer__address">
                    <div class="nd-footer__complex-address">
                        <span class="nd-footer__address-part">YouSee · Teglholmsgade 1 · 0900 København C</span>
                        <span class="nd-footer__address-part">CVR:  40 07 52 91</span>
                    </div>


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://certifikat.emaerket.dk/yousee.dk"
target="_blank"
>
                            <img alt="E-Mærket" src="//images.ctfassets.net/qn2mzafc6iit/299t3XJoVtwR9FhRTo8d3U/b37f9c77aec27e612a64180554f9db6d/E-maerket.svg?w=27&h=16"
                                 height="16" width="27">

</a>
                </address>
                <div class="nd-footer__legal">


<a
class="link _secondary _small _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"

>
                            Vilkår &amp; abonnementer

</a>


<a
class="link _secondary _small _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/persondatameddelelser"

>
                            Persondata

</a>


<a
class="link _secondary _small _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/om-yousee/om-cookies"

>
                            Cookies

</a>
                </div>
            </div>
        </div>
    </div>
`;
